import React, { useEffect, useState } from 'react';
import { CalendarIcon } from 'lucide-react';
export function MobileBookingButton() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const heroSection = document.getElementById('home');
    if (!heroSection) {
      const handleScroll = () => {
        setIsVisible(window.scrollY > 300);
      };
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(!entry.isIntersecting);
    }, {
      threshold: 0
    });
    observer.observe(heroSection);
    return () => observer.disconnect();
  }, []);
  if (!isVisible) return null;
  return <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 p-4 bg-white/90 backdrop-blur-md border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] pb-safe" data-id="element-377">
      <a href="https://appointments.4patientcare.app/?CoverKey=5118&Source=website%20WebSchedV4&ReferredBy=Unknon&Gcount=0" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-2 w-full bg-brand-gold text-white py-3.5 rounded-button font-heading font-semibold shadow-md active:scale-[0.98] transition-transform" data-id="element-378">
        <CalendarIcon className="w-5 h-5" data-id="element-379" />
        Book Appointment
      </a>
    </div>;
}